import _ from "underscore";

var SelectorUtility = require("lib/shared/SelectorUtility");
var Queries = require("lib/shared/Queries");
var QuestionTypes = require("lib/academic/QuestionTypes");

//////////////////////////////////////////////
// Quizzes ///////////////////////////////////
//////////////////////////////////////////////

export function quizzes({ state, filters, conditions }) {
	var quizzes = _.filter(SelectorUtility.filterBy(state.quizzes, filters, conditions), (quiz) => {
		if (!_.isEmpty(quiz.text_id) && quiz.text_id !== 'null' && quiz.text_id !== 'undefined') {
			return quiz
		}
	})
	return quizzes
}

export function quizzesPaginated({ state, filters, conditions, page }) {
	var query = Queries.toQuery(filters, conditions);
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.quizzes, pageKey, page);
}
export function quiz({ state, id }) {
	return state.quizzes[id];
}

export function isLoadingQuizzes({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any quizzes are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var quizzesInState = _.some(_.keys(state.quizzes), (key) => { return state.quizzes[key].id !== undefined })
		if (quizzesInState) { return false }
	}

	key = key || "index";
	return state.quizzes.loading[key];
}

export function quizTotal({ state, filters, conditions }) {
	var query = Queries.toQuery(filters, conditions)
	var totalKey = $wr.sortedJSON(query);
	return state.quizzes.totals[totalKey];
}

//////////////////////////////////////////////
// Questions /////////////////////////////////
//////////////////////////////////////////////

export function question({ state, id }) {
	return state.questions[id];
}
export function questions({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.questions, filters, conditions);
}
export function mostRecentQuestions({ state, filters, conditions, count }) {
	var sorted = _.sortBy(questions({ state, filters, conditions }), "receivedAt");
	return _.first(sorted.reverse(), count);
}
export function isLoadingQuestions({ state, key }) {
	key = key || "index";
	return state.questions.loading[key];
}

//////////////////////////////////////////////
// Answers ///////////////////////////////////
//////////////////////////////////////////////

export function answers({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.answers, filters, conditions);
}
export function answersPaginated({ state, filters, conditions, page }) {
	var query = Queries.toQuery(filters, conditions);
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.answers, pageKey, page);
}
export function isLoadingAnswers({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any answers are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var answersInState = _.some(_.keys(state.answers), (key) => { return state.answers[key].id !== undefined })
		if (answersInState) { return false }
	}

	key = key || "index";
	return state.answers.loading[key];
}
export function answer({ state, id }) {
	return state.answers[id];
}
export function answersForQuizID({ state, quizID }) {
	return _.sortBy(answers({ state, filters: { quiz_id: quizID } }), "id");
}
export function answerTotal({ state, filters, conditions }) {
	var query = Queries.toQuery(filters, conditions)
	var totalKey = $wr.sortedJSON(query);
	return state.answers.totals[totalKey];
}

//////////////////////
// Non-Quiz Answers //
//////////////////////

export function nonQuizAnswers({ state, filters, conditions, page }) {
	filters = _.extend({}, filters, { quiz_id: null });
	conditions = conditions || {};

	var oneOfMatch = _.extend({}, conditions.oneOfMatch, {
		question_type: QuestionTypes.BASIC_TYPES
	});
	var fullConditions = _.extend({}, conditions, { oneOfMatch });

	return SelectorUtility.filterBy(state.answers, filters, fullConditions);
}

export function nonQuizAnswersPaginated({ state, filters, conditions, page }) {
	var query = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.answers, pageKey, page);
}

export function nonQuizAnswerTotal({ state, filters, conditions }) {
	var query = Queries.nonQuizAnswerQuery(Queries.toQuery(filters, conditions));
	var totalKey = $wr.sortedJSON(query);
	return state.answers.totals[totalKey];
}

//////////////////////
// Reviews (Anwers) //
//////////////////////

export function reviews({ state, filters, conditions, page }) {
	filters = _.extend({}, filters, { question_type: QuestionTypes.REVIEW_QUESTION });
	return SelectorUtility.filterBy(state.answers, filters, conditions);
}

export function reviewsPaginated({ state, filters, conditions, page }) {
	var query = Queries.reviewQuery(Queries.toQuery(filters, conditions));
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.answers, pageKey, page);
}

export function reviewTotal({ state, filters, conditions }) {
	var query = Queries.reviewQuery(Queries.toQuery(filters, conditions));
	var totalKey = $wr.sortedJSON(query);
	return state.answers.totals[totalKey];
}

///////////////////////////////////////////
// Meta Cognitive (Anwers) //////
///////////////////////////////////////////

export function metaCognitiveAnswers({ state, filters, conditions, page }) {
	filters = _.extend({}, filters, { question_type: QuestionTypes.META_COGNITIVE_QUESTION });//tag change
	return SelectorUtility.filterBy(state.answers, filters, conditions);
}

export function metaCognitiveAnswersPaginated({ state, filters, conditions, page }) {
	// var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
	var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.answers, pageKey, page);
}
export function metaCognitiveAnswerTotal({ state, filters, conditions }) {
	var query = Queries.metaCogAnswerQuery(Queries.toQuery(filters, conditions));
	var totalKey = $wr.sortedJSON(query);
	return state.answers.totals[totalKey];
}

///////////////////////////////////////////
// Essay Answers //////
///////////////////////////////////////////

export function essayAnswers({ state, filters, conditions, page }) {
	filters = _.extend({}, filters, { question_type: QuestionTypes.ESSAY_QUESTION });//tag change
	return SelectorUtility.filterBy(state.answers, filters, conditions);
}

export function essayAnswersPaginated({ state, filters, conditions, page }) {
	// var query = Queries.essayAnswerQuery(Queries.toQuery(filters, conditions));
	var query = Queries.essayAnswerQuery(Queries.toQuery(filters, conditions));
	var pageKey = $wr.sortedJSON(query);
	return SelectorUtility.selectPage(state.answers, pageKey, page);
}
export function essayAnswerTotal({ state, filters, conditions }) {
	var query = Queries.essayAnswerQuery(Queries.toQuery(filters, conditions));
	var totalKey = $wr.sortedJSON(query);
	return state.answers.totals[totalKey];
}

//////////////////////////////////////////////
// Ratings ///////////////////////////////////
//////////////////////////////////////////////

export function ratings({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.ratings, filters, conditions);
}
export function isLoadingRatings({ state, key }) {
	key = key || "index";
	return state.ratings.loading[key];
}

//////////////////////////////////////////////
// Comments //////////////////////////////////
//////////////////////////////////////////////

export function comments({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.comments, filters, conditions);
}
export function isLoadingComments({ state, key }) {
	key = key || "index";
	return state.comments.loading[key];
}


//////////////////////////////////////////////
// Responses /////////////////////////////////
//////////////////////////////////////////////

export function responses({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.responses, filters, conditions);
}
export function response({ state, id }) {
	return state.responses[id];
}
export function isLoadingResponses({ state, key }) {
	key = key || "index";
	return state.responses.loading[key];
}
export function responseTotal({ state, filters, conditions }) {
	var query = Queries.toQuery(filters, conditions)
	var totalKey = $wr.sortedJSON(query);
	return state.responses.totals[totalKey];
}

//////////////////////////////////////////////
// Activities ////////////////////////////////
//////////////////////////////////////////////

export function activity({ state, id }) {
	return state.activities[id];
}

export function activities({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.activities, filters, conditions);
}

export function assignedActivities({ state, studentID }) {
	if (studentID) {
		var tks = tasks({
			state, filters: { subject_type: "Activity", user_id: studentID }
		});

	} else {
		var tks = tasks({
			state, filters: { subject_type: "Activity" }
		});
	}

	 // Actually can't just map to parseInt
	var activityIDs = _.map(_.pluck(tks, "subject_id"), (x) => parseInt(x));

	return activities({ state, conditions: { ids: activityIDs }})
}

//////////////////////////////////////////////
// Activities ////////////////////////////////
//////////////////////////////////////////////


export const getMostRecentActivities = ({ state, filters, conditions, withAssigned }) => {
    var activities = SelectorUtility.filterBy(state.activities, filters, conditions).reverse();
    var assignedActivityIDs = _.uniq(_.pluck(
    	tasks({ state, filters: {
    		subject_type: "Activity",
    		completed_at: null
    	}}),
    	"subject_id"
    ));

    if (withAssigned) {
    	activities = activities.map((activity) => {
    		var assigned = _.includes(assignedActivityIDs, activity.id + "");
    		return {
    			...activity, assigned
    		}
    	})
    }

    return activities
}

export const getActivity = ({ state, id }) => {
	return state.activities[id];	
}

//////////////////////////////////////////////
// Tasks /////////////////////////////////////
//////////////////////////////////////////////

export function tasks({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.tasks, filters, conditions);
}

export function teacherPicksTasks({ state, filters, conditions }) {
	return tasks({ state, filters, conditions }).filter(
		x => x.subject_type === "URLPick" || x.subject_type === "TitlePick"
	);
}


export function userIDsByTaskSubjectID({ state, filters, conditions }) {
	var out = {};

	_.each(tasks({ state, filters, conditions }), (task) => {
		if (!out[task.subject_id]) {
			out[task.subject_id] = [];
		}

		out[task.subject_id].push(task.user_id);
	})

	if (filters && filters.subject_type && filters.subject_type === 'exercise') {

		_.each(teacherPicksTasks({ state }), (task) => {
			var exerciseTaskItems = _.where(task.task_items, { subject_type: 'exercise', subject_assigned: true })
			if (task.task_items && !_.isEmpty(exerciseTaskItems)) {
				_.each(exerciseTaskItems, (task_item) => {
					if (!out[task_item.subject_id]) {
						out[task_item.subject_id] = [];
					}

					out[task_item.subject_id].push(task_item.user_id);
				})
				
			}

		})
	}

	return out;
}

export function task({ state, id }) {
	return state.tasks[id];
}
export function isLoadingTasks({ state, key }) {
	key = key || "index";
	return state.tasks.loading[key];
}
export function taskTotal({ state, filters, conditions }) {
	var query = Queries.toQuery(filters, conditions)
	var totalKey = $wr.sortedJSON(query);
	return state.tasks.totals[totalKey];
}
export function validStudentHomepageTasks({ state, filters, conditions }) {
	return SelectorUtility.validStudentHomepageTasks(tasks({ state, filters, conditions }))
}

//////////////////////////////////////////////
// Evaluations ///////////////////////////////
//////////////////////////////////////////////

export function evaluations({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.evaluations, filters, conditions);
}

export function evaluation({ state, id }) {
	return state.evaluations[id];
}
export function evaluationBySubjectAttributes({ state, subjectTextID, subjectUserID }) {
	return _.findWhere(state.evaluations, {
		subject_text_id: subjectTextID, subject_user_id: subjectUserID
	});
}
export function evaluationByUserTextType({ state, subjectTextID, subjectUserID, subjectType }) {
	return _.findWhere(state.evaluations, {
		subject_text_id: subjectTextID, subject_user_id: subjectUserID, subject_type: subjectType
	});
}
export function evaluationForSubject({ state, subjectType, subjectID }) {
	var filters = { subject_id: subjectID, subject_type: subjectType };
	return SelectorUtility.filterBy(state.evaluations, filters)[0];
}

export function evaluationsPaginated({ state, filters, conditions, page }) {
  var query = Queries.toQuery(filters, conditions);
  var pageKey = $wr.sortedJSON(query);
  
  return SelectorUtility.selectPage(state.evaluations, pageKey, page);
}

export function evaluationTotal({ state, filters, conditions }) {
	var query = Queries.toQuery(filters, conditions);
	var totalKey = $wr.sortedJSON(query);
	return state.evaluations.totals[totalKey];
}

export function isLoadingEvaluations({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any answers are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var evaluationsInState = _.some(_.keys(state.evaluations), (key) => { return state.evaluations[key].id !== undefined })
		if (evaluationsInState) { return false }
	}

  key = key || "index";
  return state.evaluations.loading[key];
}


// WEBPACK FOOTER //
// ./modules/lib/selectors/WritingSelectors.js